import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchEventDetails } from "../Adapter/PageAdapter";
import useSeo from "../hooks/useSeo";
import SeoHelmet from "../components/SeoHelmet";
import { Modal, Box } from "@mui/material";
import BannerImg from "../assets/images/Events.jpg";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RoomIcon from '@mui/icons-material/Room';
import { baseImage_path } from "../variables/Variables";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const EventDetails = () => {
    const { slug } = useParams();
    const [eventDetails, setEventDetails] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const seoData = useSeo(fetchEventDetails);

    useEffect(() => {
        const fetchDetails = async () => {
            try {
                const response = await fetchEventDetails(slug);
                if (response && response.data) {
                    setEventDetails(response.data);
                }
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        };
        fetchDetails();
    }, [slug]);

    if (!eventDetails) {
        return <p>Loading event details...</p>;
    }

    const handleOpen = (index) => {
        setCurrentIndex(index);
        setSelectedImage(`${baseImage_path}${eventDetails.additional_images[index]}`);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handlePrev = () => {
        const newIndex = (currentIndex - 1 + eventDetails.additional_images.length) % eventDetails.additional_images.length;
        setCurrentIndex(newIndex);
        setSelectedImage(`${baseImage_path}${eventDetails.additional_images[newIndex]}`);
    };

    const handleNext = () => {
        const newIndex = (currentIndex + 1) % eventDetails.additional_images.length;
        setCurrentIndex(newIndex);
        setSelectedImage(`${baseImage_path}${eventDetails.additional_images[newIndex]}`);
    };

    return (
        <>
            {/* <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        <img src={BannerImg} alt="News & Events" />
                        <div className="ban-con">
                            <h1>News & Events</h1>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {/* <img src={SpecdetailBan} alt="" /> */}
                        <img
                            src={
                                eventDetails?.banner_img
                                    ? `${baseImage_path}/${eventDetails.banner_img.replace(/^\.\/?/, "")}`
                                    : BannerImg
                            }
                            alt={eventDetails?.name || "Events Banner"}
                        />
                        <div className="ban-con">
                            <h1>News & Events</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="event-details-sec mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="event-details-inner">
                        {/* <div className="event-image-slider">
                            <img
                                src={`${baseImage_path}${eventDetails.main_img_path}`}
                                alt={eventDetails.heading}
                            />
                        </div> */}
                        <div className="event-details-content">
                            <h2>{eventDetails.heading}</h2>
                            <div className="event-info">
                                <h4>Date & Location</h4>
                                <div className="event-info-item">
                                    <CalendarMonthIcon />
                                    <span style={{ marginLeft: "10px" }}>
                                        {new Date(eventDetails.start_event_date).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })} -
                                        {new Date(eventDetails.end_event_date).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}
                                    </span>
                                </div>
                                <div className="event-info-item" style={{ marginTop: "10px" }}>
                                    <RoomIcon />
                                    <span style={{ marginLeft: "10px" }}>{eventDetails.location}</span>
                                </div>
                            </div>
                            <div className="about-event">
                                <h4>About the Event</h4>
                                {/* <p>{eventDetails.description}</p> */}
                                <div className="ck-content" dangerouslySetInnerHTML={{ __html: eventDetails.description }} />
                            </div>
                        </div>

                        {eventDetails.additional_images && eventDetails.additional_images.length > 0 && (
                            <div className="event-gallery">
                                <h4>Gallery</h4>
                                <div className="gallery-images">
                                    {eventDetails.additional_images.map((image, index) => (
                                        <div className="evedetailgalimage">
                                            <img
                                                key={index}
                                                src={`${baseImage_path}${image}`}
                                                alt={`Event Image ${index + 1}`}
                                                className="gallery-thumbnail"
                                                onClick={() => handleOpen(index)}
                                            />
                                        </div>

                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>

            {/* Modal for viewing images with navigation */}
            <Modal open={open} onClose={handleClose} className="image-modal">
                <div className="modal-content" style={{
                    width: "800px",
                    height: "500px",
                    margin: "auto",
                    position: "relative",
                    backgroundColor: "black",
                    padding: "10px",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <IconButton onClick={handleClose} style={{ position: "absolute", right: 10, top: 10, color: "white" }}>
                        <CloseIcon />
                    </IconButton>
                    <IconButton onClick={handlePrev} style={{ position: "absolute", left: 10, color: "white" }}>
                        <ArrowBackIosIcon />
                    </IconButton>
                    {selectedImage && <img src={selectedImage} alt="Selected Event" style={{ width: "100%", height: "100%", objectFit: "cover" }} />}
                    <IconButton onClick={handleNext} style={{ position: "absolute", right: 10, color: "white" }}>
                        <ArrowForwardIosIcon />
                    </IconButton>
                </div>
            </Modal>
        </>
    );
};

export default EventDetails;
